import React from 'react';
import { Sphere, useTexture } from '@react-three/drei';
import * as THREE from 'three';

export function UniverseBackground({ textureUrl = '/assets/textures/space_background.jpg' }) {
  // 加载纹理
  const texture = useTexture(textureUrl);
  
  // 设置纹理属性
  React.useEffect(() => {
    if (texture) {
      // 确保纹理正确包裹
      texture.wrapS = texture.wrapT = THREE.RepeatWrapping;
      texture.mapping = THREE.EquirectangularReflectionMapping; // 全景图映射
      texture.colorSpace = THREE.SRGBColorSpace; // 新版Three.js使用colorSpace替代encoding
    }
  }, [texture]);

  return (
    <Sphere args={[500, 64, 64]}>
      <meshBasicMaterial 
        map={texture} 
        side={THREE.BackSide} // 从内部查看纹理
        transparent={true}
        opacity={0.8} // 稍微透明一些，可以根据需要调整
        depthWrite={false} // 确保始终在最远处绘制
      />
    </Sphere>
  );
}
